import React, { Fragment } from 'react';
import Carousel from 'react-multi-carousel';
import Skeleton from './CarouselSkeleton';
import CoverageCards from './CoverageCards';
import { useCoverageCarousel } from './hooks';
import { getPermissions } from './helper';
import { useSelector } from 'react-redux';

const CoverageCarousel = ({
  memberAccumulatedData,
  activeMember,
  activeMemberIndex,
  defaultNetworkForAll,
  skeletonLoader,
}) => {
  const memberAccumulatedDataWithPermission = [];
  const { responsive } = useCoverageCarousel();
  const viewPermission = getPermissions();
  memberAccumulatedData.forEach((accumulateSummary) => {
    if (
      accumulateSummary.Product === 'Medical' &&
      viewPermission.verifyMedicalCoverage
    ) {
      memberAccumulatedDataWithPermission.push(accumulateSummary);
    } else if (
      accumulateSummary.Product === 'Dental' &&
      viewPermission.verifyDentalCoverage
    ) {
      memberAccumulatedDataWithPermission.push(accumulateSummary);
    } else if (
      accumulateSummary.Product === 'Prescription' &&
      viewPermission.verifyPrescriptionCoverage
    ) {
      memberAccumulatedDataWithPermission.push(accumulateSummary);
    } else if (
      accumulateSummary.Product === 'Vision' &&
      viewPermission.verifVisionCoverage
    ) {
      memberAccumulatedDataWithPermission.push(accumulateSummary);
    } else if (
      accumulateSummary.Product === 'ShortTermDisability' &&
      viewPermission.verifyShortTermDisabilityCoverage
    ) {
      memberAccumulatedDataWithPermission.push(accumulateSummary);
    } else if (
      accumulateSummary.Product === 'LongTermDisability' &&
      viewPermission.verifyLongTermDisabilityCoverage
    ) {
      memberAccumulatedDataWithPermission.push(accumulateSummary);
    } else if (
      accumulateSummary.Product === 'Supplemental' &&
      viewPermission.verifySupplementalCoverage
    ) {
      memberAccumulatedDataWithPermission.push(accumulateSummary);
    }
  });
  return (
    <div className="carousel-container p-0">
      <div className="carousel-wrapper">
        <Carousel
          additionalTransfrom={0}
          arrows
          autoPlaySpeed={3000}
          centerMode={false}
          className=""
          containerClass="container-with-dots"
          dotListClass=""
          draggable
          focusOnSelect={false}
          infinite={false}
          keyBoardControl
          minimumTouchDrag={80}
          renderButtonGroupOutside={false}
          renderDotsOutside={false}
          itemClass="slider-image-item"
          responsive={responsive}
        >
          {skeletonLoader
            ? [1, 2, 3, 4].map((item, index) => (
                <Fragment key={index}>
                  <Skeleton />
                </Fragment>
              ))
            : memberAccumulatedDataWithPermission.map(
                (accumulateSummary, index) => (
                  <Fragment key={index}>
                    <CoverageCards
                      activeMember={activeMember}
                      activeMemberIndex={activeMemberIndex}
                      accumulateSummary={accumulateSummary}
                      defaultNetworkForAll={defaultNetworkForAll}
                      skeletonLoader={skeletonLoader}
                    />
                  </Fragment>
                ),
              )}
        </Carousel>
      </div>
    </div>
  );
};
export default CoverageCarousel;
